import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_IN',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: false,
  },
  '827183b3-1d4e-44db-87bd-d34a2488e6ab',
  ''
);
